import { SetupIdentifier } from "consts/setups";
import { bootstrapEntityFactory, resourceSliceFactory } from "infrastructure/store/state";
import type { SetupsState } from "./types";

const state: SetupsState = resourceSliceFactory({
    [SetupIdentifier.Mors]: bootstrapEntityFactory(),
    [SetupIdentifier.SftpImportConsumersAllowedMerchantsFolders]: bootstrapEntityFactory()
});

export const sliceToken = 'setups';

export default state;